import React from 'react';
import { FiBookOpen } from 'react-icons/fi';

import CustomHead from '../components/CustomHead';
import Footer from '../components/FooterNew';
import Header from '../components/HeaderNew';
import { SectionContainer } from '../components/landing/sectionComponents';
import StandardFlex from '../components/landing/StandardFlex';

import Heading from '@components/Heading';

const Notebooks = () => {
  return (
    <>
      <CustomHead
        meta={{
          title: 'Notebooks | PopSQL',
          description: `Answering a business question is never just a single SQL query. It requires multiple queries, data tables, charts, slicing and dicing, and  text explanations. Notebooks let you tell a story using data.`,
          image: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/images/og/notebooks.jpg`,
        }}
      />
      <main>
        <Header />

        <div className="relative">
          <SectionContainer>
            <p className="lg:my-2 -mt-10 flex items-center space-x-3 text-center max-w-3xl text-white mx-auto font-semibold leading-normal text-md lg:text-xl font-inter fade fade-2">
              <FiBookOpen /> <span>Introducing SQL Notebooks</span>
            </p>
            <Heading
              Tag="h1"
              size="lg"
              className={`sm:text-5xl lg:text-6xl mt-4 mb-2`}
            >
              Tell stories using data
            </Heading>
            <p className="my-4 text-center max-w-3xl text-gray-500 mx-auto dark:text-cobalt-600 leading-normal text-md lg:text-xl font-inter fade fade-2">
              Answering a business question is never just a single SQL query. It
              requires multiple queries, data tables, charts, slicing and
              dicing, and text explanations. Notebooks let you tell a story
              using data.
            </p>

            <>
              <img
                className="w-3/4 mx-auto my-16"
                src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/notebooks/hero.png`}
              />
            </>
          </SectionContainer>
        </div>

        <div className="container mx-auto flex flex-col items-center pb-20 pt-0 px-6">
          <StandardFlex
            heading={
              <>
                <Heading Tag="h3" size="sm">
                  Explain your analysis with text
                </Heading>
              </>
            }
            subheading="Write an intro paragraph, document assumptions, and state your conclusion, all using Markdown."
            customContent={
              <>
                <img
                  className="w-3/4 mx-auto my-16"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/notebooks/markdown.png`}
                />
              </>
            }
          />

          <StandardFlex
            isReverse
            heading={
              <>
                <Heading Tag="h3" size="sm">
                  Support your story with data
                </Heading>
              </>
            }
            subheading="Add as many queries and charts as you want to support your story."
            customContent={
              <>
                <img
                  className="w-3/4 mx-auto my-16"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/notebooks/chart.png`}
                />
              </>
            }
          />

          <StandardFlex
            heading={
              <>
                <Heading Tag="h3" size="sm">
                  Join data across multiple sources
                </Heading>
              </>
            }
            subheading="Sometimes your data lives in different sources, like Postgres and Snowflake. Notebooks let you join them together."
            customContent={
              <>
                <img
                  className="w-full my-16"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/notebooks/multiple-connections.png`}
                />
              </>
            }
          />

          <StandardFlex
            isReverse
            heading={
              <>
                <Heading Tag="h3" size="sm">
                  Reference the results of previous queries
                </Heading>
              </>
            }
            subheading="Gather data in one query, then reference those results in subsequent queries to slice and dice your data."
            customContent={
              <>
                <img
                  className="w-2/3 my-16 mx-auto"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/notebooks/reference.png`}
                />
              </>
            }
          />

          <StandardFlex
            heading={
              <>
                <Heading Tag="h3" size="sm">
                  Share your story
                </Heading>
              </>
            }
            subheading="Easily share your notebook URL with others."
            customContent={
              <>
                <img
                  className="w-3/4 mx-auto my-16"
                  src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/notebooks/link.png`}
                />
              </>
            }
          />
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Notebooks;
